import { useContext, useEffect, useState } from 'react';

import { AuthContext } from 'utils/AuthProvider';

import SkillCardRow from './SkillCardRow';
import SkillTabBox from './SkillTabBox';
import Page from '../../components/page-layout/Page';
import SkillService from '../../services/skillService';
import SkillData from '../../types/skillData';
import erufLogo from '../../assets/images/eruf-logo.jpg';
import regionSthlmLogo from '../../assets/images/region-sthlm-logo.png';

export default function Dashboard() {
  const [inProgressSkills, setInProgressSkills] = useState<SkillData[]>([]);
  const [completedSkills, setCompletedSkills] = useState<SkillData[]>([]);
  const [allSkills, setAllSkills] = useState<SkillData[]>([]);
  const { user, userProfile } = useContext(AuthContext)!;

  useEffect(() => {
    async function fetchData() {
      const [completedSkills, inProgressSkills, rest] = await SkillService.getCompletedInProgressAndRestSkills(user);
      setCompletedSkills(completedSkills);
      setInProgressSkills(inProgressSkills);
      setAllSkills(rest);
    }

    fetchData();
  }, [user]);

  return (
    <Page className="dashboard" activeNavlink="home" breadcrumbs={[['/home', 'Home']]}>
      <section className="mb-32">
        {user && (
          <SkillCardRow
            headline={`Hello ${userProfile?.firstName}!`}
            subheadline={`You have ${inProgressSkills.length} skills in progress`}
            skills={inProgressSkills}
            className="mb-16"
          />
        )}
        <SkillTabBox
          tabLabels={!user ? ['All Skills'] : ['All Skills', 'Completed Skills']}
          component1={<SkillCardRow headline="" skills={allSkills} cardSize="sm" className="mb-8" />}
          component2={
            completedSkills.length > 0 ? (
              <SkillCardRow headline="" skills={completedSkills} completed cardSize="sm" className="mb-8" />
            ) : (
              <></>
            )
          }
        />
      </section>
      <div className="flex justify-between items-center">
        <div className="w-[360px]">
          <img className="w-[180px] mb-4" src={erufLogo} alt="eruf logo" />
          <p className="italic">Projektet delfinansieras med medel ur den Europeiska regionala utvecklingsfonden.</p>
        </div>
        <div className="w-[360px]">
          <img className="w-[200px] mb-4" src={regionSthlmLogo} alt="region sthlm logo" />
          <p className="italic">
            Region Stockholm är projektägare för Fordonsdalen React och delfinansierar projekten via Region Stockholm
            Projektmedel för hållbar regional utveckling.
          </p>
        </div>
      </div>
    </Page>
  );
}
